<script setup lang="ts">
import { useI18n } from "vue-i18n"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <RouterLink id="statisticslink-link-statistics" :to="{ name: 'Statistics' }" class="link" :title="t('views.Statistics.title')">{{
    t("views.Statistics.title")
  }}</RouterLink>
</template>
